import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { getDateFormat } from '../../../../../../utils/date';

dayjs.extend(customParseFormat);

const dateFormat = getDateFormat();

export default function controlDatesOrder(first: string, last: string) {
  if (!first || !last) return true;

  if (dayjs(last, dateFormat).isBefore(dayjs(first, dateFormat))) {
    return window.MSG_FEC_FIN_MAY_FEC_INI;
  }
  return true;
}
